<template>
  <div class="steps">
    <el-steps :active="active" align-center>
      <el-step title="确认注册协议"></el-step>
      <el-step title="填写注册信息"></el-step>
      <el-step title="完成注册"></el-step>
    </el-steps>
    <div class="back_btn" @click="back">
      返回
      <img src="@/assets/img/icon_return.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: { active: Number },
  data() {
    return {}
  },
  methods: {
    back() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.steps {
  position: relative;
  padding-bottom: 20px;
  // border-bottom: 1px solid #0774c5;
}
</style>
